import { useState, useEffect } from 'react';
import api from '../../api';

export default function ResultsViewer() {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterEmail, setFilterEmail] = useState('');

  useEffect(() => {
    api.get('/api/results')
      .then(({ data }) => setResults(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const formatDate = (d) =>
    new Date(d).toLocaleString('nl-BE', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    });

  const filtered = results.filter((r) =>
    !filterEmail ||
    r.email?.toLowerCase().includes(filterEmail.toLowerCase()) ||
    r.name?.toLowerCase().includes(filterEmail.toLowerCase())
  );

  const avg = filtered.length
    ? Math.round(filtered.reduce((s, r) => s + Number(r.percentage), 0) / filtered.length)
    : null;

  const passed = filtered.filter((r) => Number(r.percentage) >= 60).length;

  return (
    <div>
      <div className="admin-section-header">
        <div>
          <h2 className="admin-section-title">Resultaten</h2>
          <p className="admin-section-sub">{results.length} pogingen in totaal</p>
        </div>
      </div>

      {/* Stats */}
      {filtered.length > 0 && (
        <div className="stats-bar">
          <div className="stat-card">
            <div className="stat-value">{filtered.length}</div>
            <div className="stat-label">Quiz pogingen</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{avg}%</div>
            <div className="stat-label">Gemiddelde score</div>
          </div>
          <div className="stat-card">
            <div className="stat-value" style={{ color: '#16a34a' }}>{passed}</div>
            <div className="stat-label">Geslaagd (≥60%)</div>
          </div>
          <div className="stat-card">
            <div className="stat-value" style={{ color: '#dc2626' }}>{filtered.length - passed}</div>
            <div className="stat-label">Niet geslaagd</div>
          </div>
        </div>
      )}

      {/* Filter */}
      <div className="admin-search-bar">
        <input
          type="text"
          placeholder="Filter op naam of e-mail..."
          value={filterEmail}
          onChange={(e) => setFilterEmail(e.target.value)}
        />
      </div>

      {loading ? (
        <div className="admin-loading">Laden...</div>
      ) : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Leerling</th>
                <th>E-mailadres</th>
                <th>Score</th>
                <th>Totaal</th>
                <th>%</th>
                <th>Datum</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ textAlign: 'center', color: '#94a3b8', padding: '32px' }}>
                    Nog geen resultaten
                  </td>
                </tr>
              ) : (
                filtered.map((r) => {
                  const pct = Number(r.percentage);
                  const passed = pct >= 60;
                  return (
                    <tr key={r.id}>
                      <td><strong>{r.name || '—'}</strong></td>
                      <td style={{ color: '#64748b' }}>{r.email}</td>
                      <td>{r.score}</td>
                      <td>{r.total}</td>
                      <td>
                        <span className={`badge ${passed ? 'badge-pass' : 'badge-fail'}`}>
                          {pct}%
                        </span>
                      </td>
                      <td style={{ color: '#94a3b8', fontSize: '0.85rem' }}>{formatDate(r.created_at)}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
